import { right } from "@popperjs/core";

export const FR = {
  feature: {
    auth: {
      login: "Se connecter",
      $login: {
        title: "Connectez-vous à votre compte !",
      },
      forgot_password: "Mot de passe oublié",
      $forgot_password: {
        title: "Mot de passe oublié ?",
        message:
          "Saisissez votre adresse e-mail ci-dessous et nous vous enverrons un code sur l’e-mail fourni pour réinitialiser votre mot de passe",
      },
      reset_password: "Réinitialiser le mot de passe",
      $reset_password: {
        message:
          "Nous avons envoyé le code de confirmation à <b>{email}</b>. Fournissez votre nouveau mot de passe et confirmez-le une nouvelle fois dans le champ ci-dessous",
        expires_in:
          "Le code de confirmation expirera dans <b>{time}</b> secondes",
        code_expired: "Code expiré",
        code_expired_message:
          "Votre code de confirmation a expiré. Veuillez envoyer une nouvelle demande",
      },
      $update_password: {
        success_message: "Votre mot de passe a été mis à jour avec succès",
        force_message: "Votre mot de passe a expiré. Veuillez le mettre à jour",
        first_access:
          "Ceci est votre première connexion. Veuillez mettre à jour votre mot de passe",
      },
      $recovery_user_password: {
        title: "Récupération du mot de passe",
        success_message:
          "La procédure de récupération du mot de passe a été effectuée avec succès.\nL’utilisateur recevra un e-mail contenant les instructions pour réinitialiser son mot de passe.",
        error_message:
          "La procédure de récupération du mot de passe a échoué.\nVeuillez réessayer.",
        message:
          "Envoyez à cet utilisateur un e-mail contenant les instructions pour réinitialiser son mot de passe.",
      },
      request_support: "Demander de l’assistance",
      $request_support: {
        message: "Remplissez le formulaire pour demander de l’assistance",
        request_type: "Type de demande",
        $request_type: {
          1: "Je n’arrive pas à me connecter",
          2: "L’application ne fonctionne pas correctement",
          3: "J’ai une question sur une fonctionnalité",
        },
        success_message:
          "La demande d’assistance a été envoyée avec succès.\nVous recevrez une réponse dans les plus brefs délais.",
      },
      invitation: "Invitation",
      $invitation: {
        instructions: "Saisissez l’adresse email du nouvel utilisateur et soumettez le formulaire. Le système enverra un email avec les instructions pour finaliser l’inscription. L’invitation sera valide pendant 48 heures à partir de l’envoi.",
        send_success_message:
          "L’invitation a été envoyée avec succès.\nL’utilisateur recevra un e-mail avec les instructions pour accepter l’invitation.",
        accept_success_message:
          "L’invitation a été acceptée avec succès.\nVous recevrez un e-mail avec vos identifiants.",
        pending_invitations: "Invitations en attente",
        pending_invitations_message: "Le tableau répertorie toutes les invitations en attente. Une fois le lien d’invitation expiré, un bouton pour envoyer une nouvelle invitation s’affichera.",
        resend_invitation: "Renvoyer l’invitation",
        invitation_expires_date: "Date d’expiration de l’invitation",
        email_address: "Addresse e-mail",
      },
      delete_account: "Supprimer le compte",
      $delete_account: {
        disclaimer: "La suppression du compte est une opération permanente. En poursuivant, toutes vos données seront supprimées et ne pourront pas être récupérées. Assurez-vous d’avoir sauvegardé toutes les informations nécessaires avant de continuer.",
        alert_message: "Attention : cette opération supprimera définitivement votre compte et toutes les données associées. Si vous avez des doutes, nous vous invitons à contacter le support avant de confirmer.",
        success_message: "Votre compte a été supprimé avec succès. Toutes les données ont été définitivement effacées. Merci d’avoir utilisé notre service.",
      },
      $withdraw_consent: {
        alert_message: "En révoquant votre consentement, nous ne pourrons plus traiter vos données personnelles aux fins précédemment autorisées. Certains services pourraient ne plus être disponibles.",
        success_message: "Le consentement au traitement des données a été révoqué avec succès. Vous pouvez modifier vos préférences à tout moment depuis votre profil.",
      },
      $download_patient_data: {
        success_message: "Les données du patient ont été générées avec succès et sont prêtes à être téléchargées. Nous vous recommandons de les conserver dans un endroit sûr et de respecter la réglementation sur la confidentialité.",
      }
    },
    therapy: {
      name: "Thérapie",
      active_therapies:
        "Thérapies actives | Thérapie active | Thérapies actives",
      inactive_therapies:
        "Thérapies inactives | Thérapie inactive | Thérapies inactives",
      prescription: "Ordonnance",
      intake: {
        $status: {
          0: "En attente",
          1: "Pris",
          2: "Pris hors délai",
          3: "Non pris",
        },
        taken: "Pris",
        taken_in_time: "Pris à temps",
        taken_not_in_time: "Pris hors délai",
        not_taken: "Non pris",
        expected: "Prévu",
        total: "Total",
        subtotal: "Sous-total",
      },
      $trend_range: {
        day: "Jour",
        week: "Semaine",
        month: "Mois",
        year: "Année",
        $frequency: {
          day: "Quotidien",
          week: "Hebdomadaire",
          month: "Mensuel",
          year: "Annuel",
        },
      },
      $range: {
        from: "De",
        to: "À",
      },
      no_data: "Aucune donnée collectée",
      no_therapy_scheduled_today: "Aucune thérapie planifiée aujourd’hui",
      no_therapy_scheduled: "Aucune thérapie planifiée",
      provide_therapy: "Ajouter une nouvelle thérapie",
      drug: "Médicament",
      prn: "PRN",
      dose: "Dose",
      overall_adherence: "Adhésion globale",
      adherence: "Adhésion",
      intakes_per_day:
        "{count} fois par jour | {count} fois par jour | {count} fois par jour",
      add_all_prn: "Ajouter tous les PRN",
      show_prn: "Voir PRN",
      daily_calendar: "Calendrier quotidien",
    },
    home: {
      welcome_message: "Bonjour, {name} !",
      welcome_subtitle: "Bienvenue sur le portail HCP",
      your_center: "Votre centre",
      $stats: {
        center: "Statistiques du centre",
        total_patients: "Nombre total de patients",
        total_caregivers: "Nombre total d’aidants",
        total_hcps: "Nombre total de professionnels",
        centers_count: "Nombre total de centres",
        countries_count: "Pays impliqués",
        patients_invited_count: "Patients invités",
        cargivers_count: "Nombre total d’aidants",
        patients_activated_count: "Patients activés",
        therapies_started_count: "Thérapies en cours",
      },
    },
    lists: {
      result_total: "Affichage de <b>{count}</b>",
      result_counts: "Affichage de <b>{count}</b> sur <b>{total}</b>",
      result_count_range:
        "Affichage de <b>{start}</b> - <b>{end}</b> sur <b>{total}</b>",
      out_of: "sur",
    },
    surveys: {
      patient_surveys: "Questionnaires",
      history: "Historique",
      no_surveys: "Aucun questionnaire soumis",
      treshold: "Seuil recommandé",
      set_priority: "Définir la priorité",
      modal_message:
        "Une fois défini, vous ne pourrez pas le désactiver avant expiration.",
      typology: {
        table: "Tableau",
        list: "Liste",
      },
      not_available_answer: "N/A",
      PDI: {
        right_eye: "Œil droit",
        left_eye: "Œil gauche",
      },
      frequency: "Fréquence",
      $frequency: {
        D: "Quotidien",
        M: "Mensuel",
        Y: "Annuel",
        O: "Une fois",
      },
      value_representation_type: "Type de représentation des valeurs",
      $value_representation_type: {
        integer: "Entier",
        percentage: "Pourcentage",
        other: "Autre",
      },
      min_value: "Valeur minimale",
      max_value: "Valeur maximale",
      min_label: "Étiquette minimale",
      max_label: "Étiquette maximale",
      step_increment: "Incrément de pas",
      key_recommendations:
        "Fournissez une clé unique pour identifier le questionnaire (ex. questionnaire_preliminaire)",
      is_notifiable: "Envoyer des notifications",
      default_frequency_days: "Fréquence des notifications (en jours)",
      default_notification_time: "Heure de notification",
      extra: "Extra (format JSON)",
      $steps: {
        key_recommendations:
          "Fournissez une clé unique pour identifier l’étape (ex. douleur_du_jour)",
        add: "Ajouter une étape",
        save: "Enregistrer l’étape",
        delete: "Supprimer l’étape",
        discard_changes: "Annuler les modifications",
        type: "Type",
        $type: {
          R: "Radio",
          T: "Texte",
          V: "Valeur",
          D: "Description",
          F: "Finaliser",
          VSS: "Sentiment",
          VAS: "Échelle analogique visuelle",
          PDI: "Points d’intérêt",
          TS: "Plage de temps",
        },
        raw: "Brut",
        editor: "Éditeur",
        drag_reorder: "Glissez-déposez pour modifier l’ordre des étapes",
      },
      display_in_chart: "Afficher dans le graphique",
      chart_type: "Type de graphique",
      $chart_type: {
        line: "Ligne",
        bar: "Barres",
        body_map: "Carte corporelle",
      },
      labels: {
        bar_y_label: "Nombre de réponses données",
      },
      required: "Obligatoire",
      include_na_option: "Inclure l’option /NA",
      conditions: "Conditions",
      role: "Rôle",
    },
    roles: {
      type: "Type",
      $type: {
        A: "Administrateur",
        H: "Professionnel de santé",
        C: "Aidant",
        P: "Patient",
        I: "Interne",
      },
      roles_permissions: "Permissions des rôles",
      centers_permissions: "Permissions des centres",
      $permissions: {
        index: "Lister",
        show: "Afficher",
        store: "Créer",
        update: "Mettre à jour",
        destroy: "Supprimer",
      },
      center_users_management: "Gestion des utilisateurs",
      zone: "Zone",
      remind_policies: {
        title: "Rappel des politiques",
        message:
          "Veuillez vous rappeler de définir les politiques pour le rôle nouvellement créé ({type}) afin d'assurer un accès et une conformité appropriés.",
      },
      journey_schemas: "Journey Schemas",
      remind_journey_schemas: {
        title: "Rappel Journey Schemas",
        message: "Assignez des Journey Schema à ce rôle pour définir l'expérience du patient en fonction de son rôle.",
      },
    },
    contents: {
      $categories: {
        visible: "Visible",
        visibility: "Visibilité",
        $visibility: {
          all: "Public",
          restricted: "Restreint",
          undefined: "",
        },
        visibility_checkbox_message:
          "Les catégories publiques seront visibles par tous les patients",
        imageCover: "Couverture",
      },
      blocks: "Blocs",
      $blocks: {
        add: "Ajouter un bloc",
        save: "Enregistrer le bloc",
        delete: "Supprimer le bloc",
        discard_changes: "Annuler les modifications",
        type: "Type",
        $type: {
          text: "Texte",
          image: "Image",
          video: "Vidéo",
          html: "HTML",
        },
        raw: "Brut",
        editor: "Éditeur",
        drag_reorder: "Glissez-déposez pour modifier l’ordre des blocs",
      },
      content_permissions: "Contenus du patient",
      category: "Catégorie",
      lang: "Langue",
      $lang: {
        en: "Anglais",
        it: "Italien",
        de: "Allemand",
        fr: "Français",
        es: "Espagnol",
      },
    },
    consents: "Consents",
    $consents: {
      enabled_consents: "Consents associés",
      hcp_enabled_consents: "Consents associés aux professionnels",
      role_enabled_consents: "Consents associés aux rôle {role}",
      update: "Nous avons mis à jour notre politique de confidentialité.",
      update_message: "Merci de la consulter et de l'accepter pour continuer à utiliser l'application.",
    },
    consent: {
      draft: "Brouillon",
      version_history: "Historique des versions",
    },
    messages: "Messages",
    $messages: {
      send: "Envoyer un message",
      select_patient_message:
        "Sélectionnez un patient pour envoyer des messages",
    },
    $events: {
      all_day: "Toute la journée",
    },
    $caregivers: {
      no_caregivers: "Aucun aidant assigné à ce patient",
    },
    $extra_fields: {
      no_choices: "Aucune option sélectionnée",
    },
  },
  page: {
    home: "Accueil",
    patients: "Patients",
    patient: "Patient",
    caregivers: "Aidants",
    add_caregiver: "Ajouter un aidant",
    edit_caregiver: "Modifier l’aidant",
    analytics: "Analyses",
    create_patient: "Créer un nouveau patient",
    edit_patient: "Modifier le patient",
    system_users: "Utilisateurs système",
    invite_user: "Inviter un utilisateur",
    create_user: "Créer un utilisateur",
    edit_user: "Modifier l’utilisateur",
    users: "Utilisateurs",
    user: "Utilisateur",
    centers: "Centres système",
    create_center: "Créer un centre",
    edit_center: "Modifier le centre",
    center: "Centre",
    profile: "Profil",
    update_password: "Mettre à jour le mot de passe",
    roles: "Rôles système",
    create_role: "Créer un rôle",
    edit_role: "Modifier le rôle",
    content_library: "Bibliothèque de contenus",
    contents: "Contenus",
    content_categories: "Catégories",
    create_content_category: "Créer une catégorie",
    edit_content_category: "Modifier la catégorie",
    create_content: "Créer un contenu",
    edit_content: "Modifier le contenu",
    consents: "Consents",
    consent: "Consentement",
    create_consent: "Créer un consentement",
    edit_consent: "Modifier le consentement",
    consent_version: "Version du consentement",
    messages: "Messages",
    surveys: "Questionnaires",
    create_survey: "Créer un questionnaire",
    edit_survey: "Modifier le questionnaire",
    edit: "Modifier",
    create: "Créer",
    therapy_trend: "Tendance de la thérapie",
    request_support: "Demander de l’assistance",
    invitation_form: "Formulaire d’inscription",
    zones: "Zones",
    delete_account: "Supprimer le compte",
    policies: "Politiques",
    create_edit_zone: "Créer / Modifier une zone",
    privacy_and_cookies: "Politique de Confidentialité et Cookies",
    footer_link: {
      privacy_policy: "Politique de Confidentialité",
      cookie_policy: "Politique de cookies",
      terms_of_use: "Conditions d’utilisation",
    }
  },
  cta: {
    ok: "Ok",
    login: "Se connecter maintenant",
    logout: "Se déconnecter",
    submit: "Envoyer",
    back_to_login: "Retour à la connexion",
    view: "Voir",
    view_data: "Afficher les données",
    hide_data: "Masquer les données",
    edit: "Modifier",
    search: "Rechercher",
    clear_filters: "Effacer les filtres",
    delete: "Supprimer",
    $delete: {
      title: "Êtes-vous sûr ?",
      message: "Cette action est irréversible",
    },
    delete_patient: "Supprimer le patient",
    delete_user: "Supprimer l’utilisateur",
    delete_center: "Supprimer le centre",
    delete_role: "Supprimer le rôle",
    delete_category: "Supprimer la catégorie",
    delete_content: "Supprimer le contenu",
    delete_consent: "Supprimer le consentement",
    delete_event: "Supprimer l’événement",
    delete_caregiver: "Supprimer l’aidant",
    delete_zone: "Supprimer la zone",
    confirm: "Confirmer",
    continue: "Continuer",
    discard: "Annuler",
    stop: "Arrêter",
    $discard: {
      message: "Tout votre progrès sera perdu",
    },
    save: "Enregistrer",
    save_patient: "Enregistrer le patient",
    save_user: "Enregistrer l’utilisateur",
    save_center: "Enregistrer le centre",
    save_role: "Enregistrer le rôle",
    save_category: "Enregistrer la catégorie",
    save_content: "Enregistrer le contenu",
    save_consent: "Enregistrer le consentement",
    save_consent_version: "Enregistrer la version",
    save_caregiver: "Enregistrer l’aidant",
    save_zone: "Enregistrer la zone",
    create: "Créer",
    create_patient: "Créer le patient",
    create_user: "Créer l’utilisateur",
    create_center: "Créer le centre",
    create_role: "Créer un nouveau rôle",
    create_content_category: "Créer une catégorie",
    create_content: "Créer un contenu",
    create_consent: "Créer un consentement",
    create_consent_version: "Créer une version",
    restore_consent_version: "Restaurer la version",
    publish_consent: "Publier la version",
    create_caregiver: "Créer un aidant",
    create_zone: "Créer une zone",
    schedule_therapy: "Planifier une thérapie",
    update_password: "Mettre à jour le mot de passe",
    show_all: "Tout afficher",
    send: "Envoyer",
    add: "Ajouter",
    add_event: "Ajouter un événement",
    edit_event: "Modifier l’événement",
    save_event: "Enregistrer l’événement",
    add_caregiver: "Ajouter un aidant",
    load_more: "Charger plus",
    next: "Suivant",
    recovery_password: "Récupérer le mot de passe",
    create_survey: "Créer un questionnaire",
    save_survey: "Enregistrer le questionnaire",
    delete_survey: "Supprimer le questionnaire",
    invite_user: "Inviter un utilisateur",
    accept_invitation: "Accepter l’invitation",
    download_patient_data: "Télécharger les données du patient",
    withdraw_consent: "Retirer le consentement",
  },
  form: {
    first_name: {
      label: "Prénom",
      placeholder: "ex. Adam",
    },
    last_name: {
      label: "Nom",
      placeholder: "ex. Smith",
    },
    gender: {
      label: "Genre",
      0: "Inconnu",
      1: "Homme",
      2: "Femme",
      3: "Autre",
      4: "Transgenre",
      5: "Inconnu",
      $icon: {
         0: "neuter",
        1: "male",
        2: "female",
        3: "neuter",
        4: "transgender",
        5: "neuter",
      },
    },
    birth_date: {
      label: "Date de naissance",
      placeholder: "jj/mm/aaaa",
    },
    email: {
      label: "E‑mail",
      placeholder: "ex. adam127704{'@'}gmail.com",
    },
    otp: {
      label: "Code OTP",
      placeholder: "Saisissez le code OTP envoyé à votre email",
    },
    password: {
      label: "Mot de passe",
      placeholder: "Tapez votre mot de passe",
    },
    password_confirmation: {
      label: "Confirmer le mot de passe",
      placeholder: "Retapez votre mot de passe",
    },
    current_password: {
      label: "Mot de passe actuel",
      placeholder: "Tapez votre mot de passe actuel",
    },
    address: {
      label: "Adresse",
      placeholder: "Ajouter une adresse",
    },
    city: {
      label: "Ville",
      placeholder: "Ajouter une ville",
    },
    region: {
      label: "Région",
      placeholder: "Ajouter une région",
    },
    zip_code: {
      label: "Code postal",
      placeholder: "Ajouter un code postal",
    },
    country: {
      label: "Pays",
      placeholder: "Ajouter un pays",
    },
    location: {
      label: "Emplacement",
      placeholder: "Ajouter un emplacement",
    },
    phone: {
      label: "Téléphone",
      placeholder: "ex. +001 321 4567",
    },
    notes: {
      label: "Notes",
      placeholder: "Ajouter des notes supplémentaires ici",
    },
    center_id: {
      label: "Centre",
      placeholder: "Sélectionnez un centre",
    },
    add_caregiver: {
      label: "Ajouter un aidant",
    },
    section: {
      patient_information: "Informations sur le patient",
      user_information: "Informations sur l’utilisateur",
      anagraph: "Anagraph",
      credentials: "Identifiants",
      contacts: "Contacts",
      caregiver_information: "Informations sur l’aidant",
      extra: "Extra",
      personal_information: "Informations personnelles",
      department_information: "Informations sur le département",
      location: "Emplacement",
    },
    invite_user_instructions:
      "Pour activer votre compte, complétez les champs ci-dessous avec les informations demandées. Une fois terminé, vous recevrez un email contenant votre mot de passe temporaire pour accéder à la plateforme.",
    created_at: {
      label: "Créé le",
    },
    start_at: {
      label: "Début le",
    },
    end_at: {
      label: "Fin le",
      $error: {
        therapy_range_error: "La thérapie doit durer au moins {min} jours",
      },
    },
    name: {
      label: "Nom",
    },
    title: {
      label: "Titre",
    },
    description: {
      label: "Description",
      placeholder: "Ajouter une description",
    },
    website: {
      label: "Site web",
    },
    role: {
      label: "Rôle",
    },
    role_in_department: {
      label: "Rôle dans le département",
    },
    organization: {
      label: "Nom de l’organisation",
    },
    department: {
      label: "Nom du département",
    },
    main_contractor: {
      label: "Contact principal",
    },
    confirmation_code: {
      label: "Code de confirmation",
      placeholder: "Insérez le code de confirmation reçu par e‑mail",
    },
    active: {
      label: "Actif",
    },
    value: {
      label: "Valeur",
    },
    subtitle: {
      label: "Sous‑titre",
    },
    url: {
      label: "URL",
    },
    revision_number: {
      label: "Numéro de révision",
      placeholder: "ex. 1.2",
    },
    body: {
      label: "Contenu",
    },
    mandatory: {
      label: "Obligatoire",
      placeholder:
        "Fournissez le message à afficher aux utilisateurs quand ils n’acceptent pas le consentement obligatoire",
    },
    has_checkbox: {
      label: "Case à cocher pour approbation",
      placeholder: "Ajoutez le texte de l’étiquette de la case à cocher",
    },
    select_placeholder: "Sélectionnez une option",
    select_file: "Sélectionner un fichier",
    subject: {
      label: "Sujet",
      placeholder: "Insérez le sujet",
    },
    message: {
      label: "Message",
      placeholder: "Insérez votre message",
    },
    type: {
      label: "Type",
    },
    date: {
      label: "Date",
    },
    key: {
      label: "Clé",
    },
    footer: {
      label: "Pied de page",
    },
    assignment_strategy: {
      label: "Stratégie d’attribution",
      values: {
        by_hcp: "Par professionnel",
        by_center: "Par centre",
        self_registration: "Auto‑enregistrement",
      },
    },
    is_registration_enabled: {
      label: "Activer l'auto-enregistrement des patients",
    }
  },
  error: {
    something_went_wrong: "Une erreur s’est produite !",
    connection_error:
      "La requête n’a pas été envoyée ou il n’y a pas eu de réponse du serveur.\nVérifiez votre connexion internet.",
  },
  footer_disclaimer: {
    kareena: "",
    sifi_fk: "Tous droits réservés - N° TVA 00122890874",
    fungalk: "Tous droits réservés - N° TVA 00122890874",
  },
  invitation_policies: {
    terms_of_use: 'J\'ai lu les <a href="{url}" target="_blank">Conditions d\'Utilisation</a> et je les accepte.',
    privacy_policy: 'Les détails sur la manière dont nous traitons tes données personnelles sont disponibles dans notre <a href="{url}" target="_blank">Politique de Confidentialité</a>.',
    cookie_policy: '<a href="{url}" target="_blank">Politique relative aux cookies</a>.',
  },
  footer_links: {
    terms_of_use: {
      kareena: "",
      sifi_fk: 'https://karomy.it/document/KAROMY_Dashboard_Terms_of_Use.pdf',
      fungalk: "https://sifi-visionpath-dashboard-stage.azurewebsites.net/downloads/Dashboard/VisionPath_Dashboard_Terms_of_Use.pdf",
    },
    privacy_policy: {
      kareena: "",
      sifi_fk: 'https://karomy.it/document/Karomy_Platform_Privacy_Notice_Dashboard_Physician.pdf',
      fungalk: "https://sifi-visionpath-dashboard-stage.azurewebsites.net/downloads/Dashboard/VisionPath_Platform_Privacy_Notice_Dashboard_Physician.pdf",
    },
    cookie_policy: {
      kareena: "",
      sifi_fk: 'https://karomy.it/document/KAROMY_Dashboard_Cookie_Policy_EN.pdf',
      fungalk: "",
    },
  },

  "France": 'France',
  "Italy": 'Italie',
  "Spain": 'Espagne',
  "United Kingdom": 'Royaume-Uni',
  "Germany": 'Allemagne',
};
